import { createContext } from "react";
import { ListTableSort } from "sprint-common-web";

import { ContentVersionSource } from "../../../../common/types/ContentVersionSource";
import { MovieDetails, MovieVersionDetails } from "../../MovieDetails";
import { UpdatedVersionData } from "../edit-version-form/EditMovieVersionForm";
import { MovieVersionListingFilters } from "../MovieVersionListingFilters";
import { MovieVersionListingItem } from "../MovieVersionListingItem";

interface IMovieVersionListingContext {
    listingItems: MovieVersionListingItem[];
    isLoading: boolean;
    movieDetails: MovieDetails;
    totalItems: number;
    filters: MovieVersionListingFilters;
    versionsToMerge: MovieVersionListingItem[];
    clearVersionsToMerge(): void;
    clearFilters(): void;
    addNewVersionToMovie(newVersion: MovieVersionDetails): void;
    updateMovieVersion(updatedVersionData: UpdatedVersionData): void;
    setSort(sort: ListTableSort): void;
    setPage(page: number): void;
    setPageSize(pageSize: number): void;
    setSources(sources?: ContentVersionSource[]): void;
    setIncludeMerged(includeMerged?: boolean): void;
    addVersionToMergeList(versionItem?: MovieVersionListingItem): void;
    removeVersionFromMergeList(versionItem: MovieVersionListingItem): void;
    setMovieVersionAsMerged(versionId: string, mergedTargetId: string): void;
}

const defaultMovieVersionListingContext: IMovieVersionListingContext = {} as IMovieVersionListingContext;

export const MovieVersionListingContext = createContext<IMovieVersionListingContext>(defaultMovieVersionListingContext);
